<script>
import { mapState, mapActions } from "vuex";
// import cTable from "@/views/base/Table.vue";
// import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
// import StyledDialog from "@/components/dialogs/StyledModal.vue";
import moment from "moment";

export default {
  name: "CampaignAddAnother",
  data: () => {
    return {};
  },
  created() {
    //this.$store.dispatch("campaign/fetchCampaigns").then(this.filterList());
    this.newCampaign();
  },
  computed: {
    ...mapState(["campaign", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  methods: {
    newCampaign() {
      this.$store
        .dispatch("campaign/New", this.createFreshCampaignObject())
        .then(() => {
          this.$router.push({ path: "edit" });
          //,
          //params: { id: this.event.id }
        })
        .catch(() => {
          console.log("There was a problem");
          //.dispatch('notification/add', this.event)
        });
    },
    createFreshCampaignObject() {
      return {
        CampaignID: -1,
        OrderedBy: this.$store.state.n_user.n_current_user.UserProfileID,
        Dealership: {},
        Approver: {},
        StatusCode: "Created",
        PostageClass: "First Class",
        RequestedMailDate: this.GetEarliestMailDate() - 3,
        RequestedInHomeDate: this.GetEarliestMailDate(),
        BelongsTo: {
          FullName: this.$store.state.n_user.n_current_user.FullName
        }
      };
    },
    GetEarliestMailDate() {
      switch (moment().day()) {
        // If it is Monday (1),Saturday(6), or Sunday (0), Get the previous Friday (5)
        // and ensure we are on the previous week
        case 0:
          return moment().add(5, "days");
        case 1:
          return moment().add(4, "days");
        case 2:
          return moment().add(10, "days");
        case 3:
          return moment().add(9, "days");
        case 4:
          return moment().add(8, "days");
        case 5:
          return moment().add(7, "days");
        case 6:
          return moment().add(6, "days");
        default:
          return moment().add(3, "days");
      }
    }
  }
};
</script>
